<template>
    <div>
                
        <template v-if="newFolderDialogVisibility">    
            <v-dialog
                v-model="newFolderDialogVisibility"
                persistent
                max-width="600"
            >
                <v-card>
                    <v-card-title class="primary white--text">
                        <v-icon class="mr-2" color="white" >create_new_folder</v-icon>
                        Create Plan Folder
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="newFolderName" class="mt-8" label="New Folder name" required></v-text-field>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn
                            text
                            rounded
                            @click="$emit('closeNewFolderDialog')"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            rounded
                            outlined
                            dense
                            :loading="isLoadingMutation"
                            @click="createNewFolderMutation"
                        >
                            Create
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import gql from "graphql-tag";
    export default{
        name : "CreateNewFolderDialog",
        props : ["newFolderDialogVisibility"],
        data(){
            return {
                newFolderName: "",
                isLoadingMutation: false,
                createNewPlanFolderDialog: false,
            }
        },
        computed: {
            // printNewName(){
            //     return console.log(this.newFolderName)
            // }
        },
        watch: {
            
        },
        methods: {
            createNewFolderMutation(){
                this.isLoadingMutation = true
                this.$apollo.mutate({
                    mutation : gql`mutation Mutation($input: CreatePlanFolderInput!) {
                        createPlanFolder(input: $input) {
                            planFolder {
                                id
                                name
                            }
                        }
                    }`,
                    variables: {
                        input: {
                            name: this.newFolderName,
                        }
                    }
                })
                .then((response) => {
                    this.$emit("newFolderCreated", response.data.createPlanFolder.planFolder)
                    // Result
                    // console.log(response);
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    this.isLoadingMutation = false;
                    this.newFolderName = "";
                    // this.$emit('refetchPlanFolders');
                    // this.$emit('closeNewFolderDialog');
                });
            }
        }
    }
</script>